import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';

import { useFormik } from 'formik';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import ViewMetaDetails from '../ViewDetails';
import { getMetaPagesDetail, patchMetaPagesDetail, postMetaPagesDetail } from 'Services/Meta/MetaDetails';
import { useMutation, useQuery, useQueryClient } from 'react-query';

const AddMetaDetails = () => {
    const { id } = useParams()
    const { state } = useLocation()
    const { type } = useParams();

    const navegate = useNavigate();
    const client = useQueryClient()

    const { data, refetch } = useQuery(["metapages-detail-byId", state], () => getMetaPagesDetail({ details_id: state }), { enabled: Boolean(state) })
    // const getAddMeta = () => {
    //     axios
    //         .get(`${baseUrl}/blog/meta-api/?metamodel_id=${state} &page_title=${id}`, {
    //             headers: {
    //                 Authorization: `Token ${localStorage.getItem("token")}`,
    //                 "Access-Control-Allow-Origin": "*",
    //             },
    //         })
    //         .then((res) => {
    //             console.log("RESPONSE ==== : ", res.data);
    //             setData(res.data?.data[0]);
    //             // handleEdit(res.data?.news_details);
    //         })
    //         .catch((err) => {
    //             console.log("ERROR: ====", err);
    //             toast.error(err.message);
    //         });
    // };

    const Data = data?.data?.data

    const { mutate: AddMetaPages } = useMutation(postMetaPagesDetail, {
        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.message)
                client.refetchQueries("metapages-detail")
                navegate(-1)
            }
            else {
                toast.warn(res?.data?.message)
            }
        }
    })

    const { mutate: UpdateMetaPages } = useMutation(patchMetaPagesDetail, {
        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.message)
                client.refetchQueries("metapages-detail")
                navegate(-1)
            }
            else {
                toast.warn(res?.data?.message)
            }
        }
    })






    const formik = useFormik({
        initialValues: {
            // page_title: id,
            meta_pages: id,

            meta_title: Data?.meta_title || "",
            meta_tag: Data?.meta_tag || "",
            keyword: Data?.keyword || "",
            meta_description: Data?.meta_description || "",
            canonical: Data?.canonical || "",
            og_title: Data?.og_title || "",
            og_image: null,
            og_discription: Data?.og_discription || "",
            og_type: Data?.og_type || "",
            og_sitename: Data?.og_sitename || "",
            og_url: Data?.og_url || "",
            twitter_card: Data?.twitter_card || "",
            twitter_description: Data?.twitter_description || "",
            twitter_image: null,
            alternate: Data?.alternate || "",
            robots_txt: Data?.robots_txt || "",
            schema: Data?.schema || " ",
            og_locale: Data?.og_locale || "",
            fb_admin: Data?.fb_admin || "",
            twitter_title: Data?.twitter_title || "",
            twitter_site: Data?.twitter_site || " ",
            url: Data?.url || " ",
            lang: Data?.lang || " ",
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            const reqbody = new FormData();
            reqbody.append("store", localStorage.getItem("store_id"));
            reqbody.append("meta_title", values.meta_title);
            reqbody.append("meta_tag", values.meta_tag);
            reqbody.append("keyword", values.keyword);
            reqbody.append("meta_description", values.meta_description);
            reqbody.append("canonical", values.canonical);
            reqbody.append("og_title", values.og_title);
            if (values.og_image) reqbody.append("og_image", values.og_image);
            reqbody.append("og_discription", values.og_discription);
            reqbody.append("og_type", values.og_type);
            reqbody.append("og_sitename", values.og_sitename);
            reqbody.append("og_url", values.og_url);
            reqbody.append("twitter_card", values.twitter_card);
            reqbody.append("twitter_description", values.twitter_description);
            if (values.twitter_image) reqbody.append("twitter_image", values.twitter_image);
            reqbody.append("alternate", values.alternate);
            reqbody.append("robots_txt", values.robots_txt)
            reqbody.append("schema", values.schema)
            reqbody.append("og_locale", values.og_locale);
            reqbody.append("fb_admin", values.fb_admin);
            reqbody.append("twitter_title", values.twitter_title);
            reqbody.append("twitter_site", values.twitter_site)
            reqbody.append("url", values.url)
            reqbody.append("lang", values.lang)

            reqbody.append("meta_pages", id)
            type === "update" && reqbody.append("details_id", state)
            type === "add"
                ? AddMetaPages(reqbody)
                : UpdateMetaPages(reqbody)
        },
    });


    return (
        <div className="w-full flex justify-center text-black">
            {type !== "view" ? (
                <div className="w-full lg:w-[80%] mt-6">
                    <div className="bg-white shadow-xl rounded-lg p-6">
                        <h2 className="text-xl font-bold text-orange-600 mb-6">
                            SEO & Meta Details
                        </h2>

                        <form onSubmit={formik.handleSubmit} className="space-y-6">
                            {/* Basic Info */}
                            <div>
                                <h3 className="text-lg font-semibold text-gray-700 mb-3">
                                    Basic Information
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <InputField id="meta_title" label="Meta Title" placeholder="Enter title" formik={formik} />
                                    <InputField id="meta_tag" label="Meta Tag" placeholder="Enter Website Name" formik={formik} />
                                    <InputField id="keyword" label="Meta Keyword" placeholder="Enter keywords" formik={formik} />
                                    <InputField id="meta_description" label="Meta Description" placeholder="Enter description" formik={formik} />
                                    <InputField id="canonical" label="Canonical" placeholder="https://yourwebsite.com" formik={formik} />
                                    <InputField id="url" label="URL" placeholder="https://yourwebsite.com/" formik={formik} />
                                </div>
                            </div>

                            {/* OG Data */}
                            <div>
                                <h3 className="text-lg font-semibold text-gray-700 mb-3">
                                    Open Graph (OG) Tags
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <InputField id="og_title" label="OG Title" placeholder="Enter OG Title" formik={formik} />
                                    <InputField id="og_locale" label="OG Locale" placeholder="en_US" formik={formik} />
                                    <FileField id="og_image" label="OG Image" formik={formik} />
                                    <InputField id="og_discription" label="OG Description" placeholder="Enter OG Description" formik={formik} />
                                    <InputField id="og_type" label="OG Type" placeholder="website" formik={formik} />
                                    <InputField id="og_sitename" label="OG Sitename" placeholder="Website Name" formik={formik} />
                                    <InputField id="og_url" label="OG URL" placeholder="Enter OG URL" formik={formik} />
                                </div>
                            </div>

                            {/* Twitter Data */}
                            <div>
                                <h3 className="text-lg font-semibold text-gray-700 mb-3">
                                    Twitter Meta Tags
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <InputField id="twitter_title" label="Twitter Title" placeholder="Enter Twitter Title" formik={formik} />
                                    <InputField id="twitter_card" label="Twitter Card" placeholder="summary" formik={formik} />
                                    <InputField id="twitter_description" label="Twitter Description" placeholder="Short website description" formik={formik} />
                                    <InputField id="twitter_site" label="Twitter Site" placeholder="@yoursite" formik={formik} />
                                    <FileField id="twitter_image" label="Twitter Image" formik={formik} />
                                </div>
                            </div>

                            {/* Extra SEO */}
                            <div>
                                <h3 className="text-lg font-semibold text-gray-700 mb-3">
                                    Extra SEO Settings
                                </h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <InputField id="fb_admin" label="Facebook Admin" placeholder="Enter Facebook Admin" formik={formik} />
                                    <InputField id="lang" label="Language" placeholder="en_US" formik={formik} />
                                    <InputField id="alternate" label="Alternate" placeholder="https://alternate.com" formik={formik} />
                                    <InputField id="robots_txt" label="Robots" placeholder="index,follow" formik={formik} />
                                    <InputField id="schema" label="Schema" placeholder="Business Schema JSON" formik={formik} />
                                </div>
                            </div>

                            <div className="pt-4">
                                <Button type="submit" variant="contained" className="!bg-orange-600 !text-white">
                                    Save Meta Details
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            ) : (
                <ViewMetaDetails data={data?.data?.data} />
            )}
        </div>
    );
};

const InputField = ({ id, label, placeholder, formik }) => (
    <div className="flex flex-col">
        <label htmlFor={id} className="text-sm font-semibold text-gray-600 mb-1">
            {label}
        </label>
        <input
            id={id}
            placeholder={placeholder}
            value={formik.values[id] || ""}
            onChange={formik.handleChange}
            className="w-full p-2 px-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-400 outline-none"
        />
    </div>
);

const FileField = ({ id, label, formik }) => (
    <div className="flex flex-col">
        <label htmlFor={id} className="text-sm font-semibold text-gray-600 mb-1">
            {label}
        </label>
        <input
            id={id}
            type="file"
            className="w-full p-2 px-3 border border-gray-300 rounded-lg bg-gray-50"
            onChange={(e) => formik.setFieldValue(id, e.target.files[0])}
        />
    </div>
);



export default AddMetaDetails